<template>
  <LayoutDefault>
    <section class="material-support">
      <h1 class="material-support__title">Материально-техническое обеспечение и оснащенность <br /> образовательного
        процесса</h1>
        <h2 class="material-support__subtitle">Об оборудованных учебных кабинетах</h2>
      <MaterialSupportAdressTable :data="dataSource" />
      <table class="material-support__categories-table">
        <thead>
          <tr>
            <th class="material-support__table-title">Категория</th>
            <th class="material-support__table-title">Наполнение</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, idx) in test1"
            :key="idx"
          >
            <td class="material-support__categories">
              <p>{{ item.name }}</p>
            </td>
            <td class="material-support__filling">
              <Textarea
                v-model="item.description"
                autoResize
                rows="1"
                cols="70"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <MaterialSupportCabinetsTable :data="dataSource"/>
      <table class="material-support__categories-table">
        <thead>
          <tr>
            <th class="material-support__table-title">Категория</th>
            <th class="material-support__table-title">Наполнение</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, idx) in test2"
            :key="idx"
          >
            <td class="material-support__categories">
              <p>{{ item.name }}</p>
            </td>
            <td class="material-support__filling">
              <Textarea
                v-model="item.description"
                autoResize
                rows="1"
                cols="70"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </LayoutDefault>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import LayoutDefault from '@/layout/LayoutDefault'
import MaterialSupportAdressTable from '@/components/blocks/MaterialSupportAdressTable.vue'
import MaterialSupportCabinetsTable from '@/components/blocks/MaterialSupportCabinetsTable.vue'

import Textarea from 'primevue/textarea'

export default {
  name: 'MaterialSupportView',
  components: {
    LayoutDefault,
    MaterialSupportAdressTable,
    Textarea,
    MaterialSupportCabinetsTable
  },
  props: {
  },
  setup () {
    const store = useStore()

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    const test1 = ref([
      {
        id: 1,
        name: 'об объектах для проведения практических занятий',
        description: 'При реализации образовательных программ с применением электронного обучения, дистанционных образовательных технологий проведение практических занятий осуществляется с использованием платформы «Moodle», программы Zoom и электронной почты. Учебный класс оборудован доступом к сети «Интернет».'
      },
      {
        id: 2,
        name: 'о библиотеке',
        description: 'Все электронные издания, необходимые для обучения образовательной программы размещены в системе «Moodle», доступ к которой осуществляется с использованием идентификационных данных в период срока действия договора об оказании платных образовательных услуг.'
      },
      {
        id: 3,
        name: 'об объектах спорта',
        description: 'Объекты спорта отсутствуют.'
      }
    ])

    const test2 = ref([
      {
        id: 1,
        name: 'Об организации питания обучающихся',
        description: 'Созданы условия питания обучающихся. Расписание занятий предусматривает перерыв на обед с достаточной продолжительностью. С целью обеспечения возможности питания обучающихся заключен договор на оказание услуг по организации питания с кафе, находящимся в шаговой доступности. Для соблюдения питьевого режима учебный класс оснащен бутилированной питьевой водой, одноразовыми стаканчиками, кулером и термопотом.'
      },
      {
        id: 2,
        name: 'Об условиях охраны здоровья обучающихся',
        description: 'Образовательная организация создает условия для охраны здоровья обучающихся. Образовательная организация обеспечивает: соблюдение государственных санитарно-эпидемиологических правил и нормативов; расследование и учет несчастных случаев с обучающимися во время пребывания в Образовательной организации в порядке, установленном действующими нормативными правовыми актами; проведение санитарно-противоэпидемических и профилактических мероприятий; обучение педагогических работников навыкам оказания доврачебной помощи; оснащение лицензируемого медицинского кабинет необходимым оборудованием для оказания доврачебной помощи. Штатный медицинский работник сможет оказывать первичную доврачебную помощь и в случае необходимости осуществить вызов службы скорой медицинской помощи. \n\n Образовательная организация осуществляет влажную уборку учебных аудиторий, поддерживает режим «проветривания» помещений, уборку санузлов с применением моющих и дезинфицирующих средств, организует проведение дезинфекции, дератизации и дезинсекции помещений.'
      }
    ])

    return {
      dataSource,
      test1,
      test2
    }
  }
}
</script>

<style lang="scss" scoped>
.material-support {
  &__title {
    @include information-block-title;
    margin-bottom: 24px
  }

  &__subtitle {
    font-size: 24px;
    text-align: left;
    margin-bottom: 16px;
  }

  :deep(.offices-table) {
    margin-bottom: 24px;
  }

  :deep(.cabinets-table) {
    width: 45%;
    margin-bottom: 24px;
  }

  &__categories-table {
    text-align: left;
    margin-bottom: 32px;

    tr {
      vertical-align: top;
    }
  }

  &__table-title {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 8px;
  }

  &__categories {
    width: 15%;

    p {
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__filling {
    :deep(.p-inputtextarea) {
      margin-bottom: 10px;
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
